import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Fade } from '@mui/material';
import clsx from 'clsx';

import scss from './CommonDropArea.module.scss';

const OVERLAY_FADE_TIMEOUT = 150;

function CommonDropArea({
  accept,
  onDrop,
  onDropRejected,
  multiple = true,
  disabled = false,
  overlayIcon,
  overlayLabel,
  renderHeader,
  className,
  contentClassName,
  children,
}) {
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    accept,
    multiple,
    disabled,
    noClick: true,
    noKeyboard: true,
    onDrop: (files) => {
      if (files.length) {
        onDrop(files);
      }
    },
    onDropRejected,
  });

  return (
    <div {...getRootProps({ className: clsx(scss.root, className) })}>
      <input {...getInputProps()} />

      {renderHeader ? renderHeader({ open, isDragActive }) : null}

      <div className={clsx(scss.content, isDragActive && scss.active, contentClassName)}>
        {children}

        <Fade in={isDragActive} timeout={OVERLAY_FADE_TIMEOUT}>
          <div className={scss.overlay} aria-hidden={!isDragActive}>
            {overlayIcon}
            {overlayLabel}
          </div>
        </Fade>
      </div>
    </div>
  );
}

export default CommonDropArea;
